var React = require('react');

function PlayerPlay (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(2 2)"},[React.createElement("circle",{"cx":"14.5","cy":"14.5","r":"14.5","stroke":"#FFF","strokeWidth":"2.268","key":0}),React.createElement("path",{"fill":"#FFF","d":"M22 14.5L11 22V7z","key":1})]));
}

PlayerPlay.displayName = "PlayerPlay";

PlayerPlay.defaultProps = {"width":"18","height":"18","viewBox":"0 0 33 33"};

module.exports = PlayerPlay;

PlayerPlay.default = PlayerPlay;
